import { useEffect, useRef } from 'react';
import QR from 'qrcode';

export function QRCode({ value, size = 200 }: { value: string; size?: number }) {
  const ref = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (!ref.current) return;
    QR.toCanvas(ref.current, value, {
      width: size,
      margin: 1,
      color: {
        dark: '#0a0a0a',
        light: '#ffffff',
      },
      errorCorrectionLevel: 'M',
    }).catch((err) => console.error('QR render failed', err));
  }, [value, size]);

  return <canvas ref={ref} width={size} height={size} className="rounded-md" />;
}
